export default (value) => {

    return value.split('').reverse().join('');
}
